import { createFileRoute } from "@tanstack/react-router";
import { AboutPage } from "../pages/AboutPage";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { buildCompleteHead } from "../utils/seo";
import { LangProvider } from "../contexts/LangContext";

export const Route = createFileRoute("/about")({
  head: () => {
    const seoData = buildCompleteHead(
      "default",
      "home",
      "https://lotin.uz/about",
      "/about",
      "/about",
    );
    return {
      meta: [{ title: "About — Lotin.uz" }, ...seoData.meta],
      links: seoData.links,
      htmlProps: { lang: "uz-Latn" },
    };
  },
  component: About,
});

function About() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    // Guard for SSR: only call changeLanguage if it exists
    if (i18n?.changeLanguage) {
      i18n.changeLanguage("default");
    }
    document.title = "About — Lotin.uz";
  }, [i18n]);

  return (
    <LangProvider lang={"uz-Latn"}>
      <AboutPage lang="uz-Latn" />
    </LangProvider>
  );
}
